import { useEffect, useRef } from 'react'

import { gHistory } from 'src/platform/router/history'

export const useIntercomUrlUpdates = (enabled: boolean) => {
  const lastUrl = useRef(window.location.href)

  useEffect(() => {
    if (!enabled) return

    let timer: ReturnType<typeof setTimeout>
    const scheduleUpdate = () => {
      clearTimeout(timer)
      // Let immediate redirects settle so Intercom sees the canonical URL.
      timer = setTimeout(() => {
        const url = window.location.href
        if (url === lastUrl.current || typeof window.Intercom !== 'function') {
          return
        }
        // SPA navigation alone does not refresh Intercom's URL targeting.
        // https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app
        window.Intercom('update', {
          last_request_at: Math.floor(Date.now() / 1000),
        })
        lastUrl.current = url
      }, 0)
    }

    const listener = gHistory.listen(scheduleUpdate)
    // A child may have redirected between render (boot) and this effect.
    scheduleUpdate()
    return () => {
      gHistory.remove(listener)
      clearTimeout(timer)
    }
  }, [enabled])
}
